import styled from "styled-components";
import { Flex } from "../../../components/Container/Flex";
import { Colors, darken, isDark } from "../../../utils/style/colors";
import { Shadows } from "../../../utils/style/shadows";

// ---- Page / phone mockup ----------------------------------------------------

export const ComposerArea = styled(Flex)`
  height: 100%;
  width: 100%;
  /* No global border-box: the padding would otherwise overflow the dialog. */
  box-sizing: border-box;
  overflow: auto;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
`;

export const PhoneFrame = styled.div`
  width: 380px;
  min-width: 380px;
  height: 760px;
  background: ${Colors.gray60};
  border-radius: 44px;
  padding: 14px;
  box-shadow: ${Shadows.small};
  position: relative;
`;

export const Notch = styled.div`
  position: absolute;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  width: 150px;
  height: 26px;
  background: ${Colors.gray60};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  z-index: 6;
`;

export const PhoneScreen = styled.div`
  width: 100%;
  height: 100%;
  background: ${Colors.gray10};
  border-radius: 32px;
  overflow-y: auto;
  position: relative;
  /* scrollable, but hide the scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const GridWrap = styled.div`
  width: 100%;
  min-height: 100%;
  padding-top: 20px;
  /* include padding in the 100% so the page doesn't overflow (and scroll
     tiles under the notch) when the tiles already fit */
  box-sizing: border-box;
`;

export const ButtonBar = styled(Flex)`
  overflow: hidden;
  transition: all 0.3s;
  height: ${(props) => (props.show ? 50 : 0)}px;
  margin-top: ${(props) => (props.show ? 16 : 0)}px;
`;

// ---- Tile -------------------------------------------------------------------

export const TileBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.bgColor || Colors.white};
  border-radius: 14px;
  box-shadow: ${Shadows.small};
  padding: 6px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;

export const TileIcon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  background: ${(props) =>
    `linear-gradient(45deg, ${props.color}, ${darken(props.color, 1.1)})`};
`;

export const TileLabel = styled.span`
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  width: 100%;
  padding: 0 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: ${(props) => (isDark(props.bgColor) ? Colors.white : Colors.gray60)};
`;

export const EditDot = styled.div`
  position: absolute;
  top: -10px;
  ${(props) => (props.left ? "left: -10px;" : "right: -10px;")};
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: ${(props) => props.color || Colors.gray60};
  display: ${(props) => (props.visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: ${Shadows.small};
`;

// ---- Drawer -----------------------------------------------------------------

export const ExampleArea = styled(Flex)`
  height: 200px;
  min-height: 200px;
  background: ${Colors.gray60};
  align-items: center;
  justify-content: center;
`;

export const PreviewTile = styled.div`
  width: 120px;
  height: 120px;
`;

export const DrawerHeader = styled(Flex)`
  height: 48px;
  min-height: 48px;
  align-items: center;
  padding: 0 6px;
`;

export const DrawerBody = styled(Flex)`
  padding: 20px;
  overflow: auto;
`;

export const LibraryCard = styled(Flex)`
  border-radius: 12px;
  background: ${Colors.white};
  box-shadow: ${Shadows.small};
  padding: 16px;
  margin-bottom: 16px;
`;
